export const error = "/error";
export const fallback = "*";
export const home = "/home";
export const login = "/login";
export const verificationCode = "/verificationcode/:email";
export const emailVerification = "/email-verification";
export const changePassword = "/reset-password/:email/:otp";
export const materials = "/materials";
export const shippingLines = "/shipping-lines";
export const bulkInsert = "/bulk-insert";
export const warehouses = "/warehouses";
export const storageLocations = "/storage-locations";
export const banks = "/banks";
export const clearanceAgents = "/clearance-agents";
export const agentPortfolio = `${clearanceAgents}/agent-portfolio/:agentId`;
export const vendors = "/vendors";
export const vendorPortfolio = `${vendors}/vendor-documents/:vendorId`;
export const suppliers = "/suppliers";
export const categories = "/categories";
export const users = "/users";
export const planners = "/planners";
export const profile = "/profile";
export const pendingOrders = "/my-pending-orders";
export const payments="/payments"
export const paymentPreview = `${payments}/payment-preview/:invoiceId`;
export const allPendingOrders = "/All-pending-orders";
export const groupView = "/group-view";
export const transactionOrderListing="/transaction-order-listing"
export const transactionDetails=`${transactionOrderListing}/transaction-details/:orderId`
export const transactionGroupDetails=`${transactionOrderListing}/transaction-group-details/:groupId`
export const releasedOrders = "/released-orders";
export const clearanceDashboard = "/clearance-dashboard";
export const paymentDashboard = "/payment-dashboard";
export const allReleasedOrders = "/all-released-orders";
export const addneworders = `${pendingOrders}/new-orders`;
export const orderInfo = "/order-info/:orderId";
export const otherOrderInfo = "/other-order-info/:orderId";
export const canceledOrders = "/canceled-orders";
export const editorder = `${pendingOrders}/edit-order/:orderId`;
export const invoice=`${pendingOrders}/invoice`
export const approval=`${pendingOrders}/approval/:orderId`
export const cargox=`${pendingOrders}/cargox/:orderId`
export const notifications = "/notifications";
export const msdsdirectory = "/msds-directory";
export const starredOrders = "/starred-orders";
